// extracted by mini-css-extract-plugin
module.exports = {"root":"BarChart_root__IRBwu"};